export default "__VITE_PUBLIC_ASSET__d3299165__"